// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".version[data-v-61586642]{-webkit-box-align:center;-webkit-align-items:center;align-items:center;display:-webkit-inline-box;display:-webkit-inline-flex;display:inline-flex;font-weight:700;-webkit-box-pack:end;-webkit-justify-content:flex-end;justify-content:flex-end}", ""]);
// Exports
module.exports = exports;
